module.exports = __webpack_public_path__ + "media/packs/images/flags/NZ-556428a4c3b3088fb0a391570bdefb3f.svg";